import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { IPD_COLORS } from '../theme';
import { invChipSx } from './StatusChip';
import { formatDate, daysUntilExpiry } from '../utils';

export default function BatchChip({ batchNumber, expiryDate }) {
  if (!batchNumber) return <span style={{ color: IPD_COLORS.textSecondary }}>—</span>;

  const days = daysUntilExpiry(expiryDate);
  let color = IPD_COLORS.primary;
  if (days !== null && days <= 30) color = IPD_COLORS.error.text;
  else if (days !== null && days <= 90) color = IPD_COLORS.warning.text;

  const label = expiryDate ? `${batchNumber} · ${formatDate(expiryDate)}` : batchNumber;

  return (
    <Tooltip title={days !== null ? `Expires in ${days} days` : ''}>
      <Chip
        label={label}
        size="small"
        sx={{ ...invChipSx({ color, variant: 'soft' }), fontFamily: 'monospace' }}
      />
    </Tooltip>
  );
}
